var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 108,
    viewBox: "0 0 402 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_684_31971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 402,
    height: 108
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.918945,
    y: 0.0515137,
    width: 400.441,
    height: 107.149,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_684_31971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.41943 27.2002C88.1706 38.3953 212.406 165.638 200.941 209.885C193.423 238.89 105.343 238.239 81.279 243.47C48.4628 250.594 110.599 223.924 123.255 193.092C138.291 156.453 115.467 60.1343 187.872 77.0695C251.062 91.8573 264.744 139.752 310.041 138.643C351.008 137.625 382.922 97.4243 403.39 63.8389",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.42578 30.1365C84.4052 42.6191 203.923 165.847 194.369 208.241C188.104 236.015 104.685 235.089 82.4192 239.791C51.5514 246.3 111.038 220.668 123.587 191.087C138.623 155.619 117.873 63.442 187.772 79.7717C250.128 94.3 262.714 143.309 308.418 143.381C349.46 143.319 382.634 103.989 404.004 71.1209",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.43262 33.0571C80.6394 46.8272 195.44 166.03 187.803 206.582C182.791 233.125 104.027 231.924 83.5589 236.096C54.6332 241.969 111.476 217.395 123.918 189.062C138.954 154.764 120.285 66.7393 187.671 82.4583C249.194 96.7321 260.684 146.983 306.801 148.103C347.912 149.12 382.345 110.543 404.623 78.3873",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.43262 35.9985C76.8803 51.0611 186.963 166.218 181.237 204.944C177.478 230.239 103.369 228.779 84.6991 232.423C57.7031 237.623 111.921 214.124 124.25 187.041C139.33 153.909 122.697 70.0369 187.577 85.1402C248.26 99.1646 258.642 150.606 305.172 152.82C346.352 154.799 382.05 117.102 405.237 85.649",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.43896 38.9297C73.1526 55.2797 178.48 166.381 174.671 203.295C172.165 227.339 102.717 225.619 85.8455 228.708C60.7854 233.288 112.372 210.857 124.582 185.021C139.687 153.059 125.109 73.3395 187.477 87.8271C247.327 101.597 256.605 154.174 303.562 157.542C344.798 160.499 381.775 123.657 405.857 92.9158",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.44482 41.8606C69.4002 59.5031 169.998 166.534 168.1 201.646C166.847 224.423 102.066 222.459 86.9862 225.018C63.8807 228.937 112.836 207.584 124.915 183.001C140.051 152.204 127.521 76.647 187.383 90.5188C246.388 104.039 254.563 157.766 301.94 162.27C343.245 166.198 381.506 130.211 406.478 100.187",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.44482 44.7971C65.6474 63.7271 161.509 166.611 161.534 200.003C161.534 221.492 101.389 219.289 88.1264 221.324C66.9631 224.566 113.299 204.318 125.247 180.986C140.421 151.349 129.927 79.9397 187.271 93.2111C245.441 106.472 252.502 161.349 300.311 166.997C341.66 171.882 381.186 136.786 407.086 107.459",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.4502 47.728C61.8893 67.9454 153.008 166.687 154.969 198.354C156.222 218.546 100.776 216.113 89.2738 217.635C70.0464 220.179 113.783 201.051 125.611 178.961C140.835 150.464 132.34 83.3337 187.215 95.8926C244.515 109.006 250.492 164.916 298.733 171.714C340.163 177.556 380.943 143.34 407.744 114.721",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.45703 50.6594C58.136 72.1694 144.481 166.733 148.396 196.705C150.865 215.579 100.156 212.933 90.4135 213.941C73.1408 215.732 114.264 197.784 125.917 176.951C141.185 149.635 134.688 86.6518 187.089 98.5849C243.55 111.454 248.43 168.478 297.084 176.442C338.572 183.23 380.629 149.904 408.333 121.993",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.45703 53.5901C54.3832 76.3875 135.929 166.737 141.831 195.056C145.489 212.597 99.5416 209.737 91.5537 210.251C76.2419 211.233 114.734 194.517 126.249 174.93C141.586 148.779 137.126 89.9489 187.02 101.281C242.641 113.907 246.419 172.04 295.493 181.174C337.043 188.904 380.372 156.468 408.984 129.269",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.46387 56.5212C50.6299 80.6112 127.326 166.712 135.264 193.407C140.076 209.6 98.9772 206.531 92.662 206.562C79.3551 206.623 115.216 191.255 126.55 172.91C141.962 147.919 139.499 93.2617 186.863 103.968C241.638 116.354 244.314 175.587 293.814 185.896C335.426 194.547 380.02 163.028 409.535 136.536",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.46924 59.4575C46.8781 84.8298 118.669 166.656 128.699 191.764C134.62 206.587 98.2764 204.145 93.8408 202.867C82.6389 203.885 115.768 187.993 126.914 170.895C142.414 147.065 141.95 96.5644 186.795 106.66C240.737 118.797 242.31 179.129 292.223 190.624C333.904 200.216 379.765 169.592 410.188 143.808",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.46924 62.3884C43.119 89.0532 109.923 166.58 122.127 190.115C129.107 203.569 97.6374 201.045 94.981 199.178C85.7463 199.646 116.326 184.736 127.246 168.875C142.852 146.21 144.356 99.8667 186.695 109.337C239.797 121.229 240.274 182.655 290.607 195.336C332.357 205.854 379.476 176.141 410.808 151.064",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.47559 65.3198C39.3662 93.2721 101.083 166.509 115.562 188.466C123.531 200.557 96.992 197.947 96.14 195.484C88.8663 195.397 116.896 181.48 127.597 166.86C143.328 145.355 146.787 103.165 186.62 112.039C238.883 123.682 238.262 186.197 289.009 200.074C330.828 211.508 379.226 182.716 411.44 158.346",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.48291 68.2507C35.6124 97.4955 92.1355 166.463 108.995 186.818C117.891 197.56 96.3519 194.848 97.2603 191.794C91.9539 191.148 117.446 178.233 127.909 164.824C143.791 144.469 149.179 106.447 186.5 114.711C237.929 126.104 236.213 189.703 287.367 204.781C329.261 217.136 378.905 189.26 412.041 165.598",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.48291 71.1819C31.8596 101.714 83.0951 166.488 102.423 185.169C112.19 194.598 95.7066 191.749 98.4068 188.105C95.0613 186.904 118.035 174.991 128.241 162.824C144.298 143.681 151.591 109.754 186.399 117.418C236.996 128.552 234.189 193.24 285.75 209.523C327.726 222.785 378.617 195.835 412.661 172.885",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.48828 74.1128C28.1078 105.938 73.9177 166.615 95.8579 183.52C106.452 191.687 95.0685 188.649 99.548 184.41C98.1697 182.655 118.644 171.765 128.574 160.804C144.832 142.861 154.004 113.046 186.306 120.094C236.063 130.969 232.173 196.73 284.129 214.235C326.186 228.402 378.33 202.384 413.276 180.141",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.49609 77.0491C24.3472 110.156 64.7065 166.88 89.2906 181.876C100.699 188.833 94.4216 185.55 100.687 180.721C101.276 178.411 119.275 168.549 128.879 158.784C145.381 142.067 156.395 116.339 186.179 122.797C235.103 133.406 230.135 200.257 282.485 218.973C324.624 234.041 378.021 208.958 413.87 187.423",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.49561 80.4045C20.5949 114.804 55.4849 167.706 82.7253 180.652C94.9546 186.463 94.6852 183.654 101.827 177.456C104.803 174.871 119.927 165.752 129.243 157.193C146.021 141.734 158.839 120.046 186.111 125.913C234.201 136.253 228.149 204.182 280.888 224.125C323.121 240.093 377.758 215.942 414.515 195.119",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.50195 82.9263C16.8421 118.613 46.3128 167.836 76.1845 178.594C89.2847 183.316 93.5762 179.78 103.005 173.353C107.735 170.126 120.629 162.193 129.606 154.764C146.716 140.612 161.282 122.923 186.042 128.19C233.305 138.251 226.176 207.274 279.303 228.438C321.63 245.302 377.501 222.097 415.16 201.977",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.50732 85.8428C13.0902 122.822 37.2294 168.463 69.5883 176.931C83.6032 180.6 92.6499 176.422 104.115 169.649C110.681 165.766 121.281 159.034 129.908 152.734C147.4 139.956 163.683 126.161 185.911 130.852C232.373 140.572 224.184 210.684 277.65 233.135C320.102 250.849 377.183 228.627 415.75 209.218",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.50732 88.7737C9.33745 127.041 28.2579 169.175 63.0226 175.282C107.924 183.195 142.545 124.578 185.817 133.554C231.439 143.024 222.154 214.246 276.034 237.873C318.555 256.528 376.901 235.206 416.371 216.5",
    stroke: "#4A3AFF",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/mask.13f70c840106f7f7e3e5733156f037ad.svg";
export { ForwardRef as ReactComponent };